import { WorkflowGroupDomainService } from "../WorkflowGroup/WorkflowGroup.service";
export default class StageDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { workflowGroup: json.workflowGroup &&
                WorkflowGroupDomainService.fromJSON(json.workflowGroup) });
    }
}
